import { ActionType, IPatientCSVResponse } from "models/patients/downloadCSV";
import { PatientsPayload } from "models/patients/patientList";

export const downloadPatientCSVAction = (payload: PatientsPayload) => {
  return {
    type: ActionType.DOWNLOAD_PATIENT_CSV,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DOWNLOAD_PATIENT_CSV_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IPatientCSVResponse) => {
  return {
    type: ActionType.DOWNLOAD_PATIENT_CSV_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.DOWNLOAD_PATIENT_CSV_RESET,
  };
};
